/**
 * Error Reporter — sends frontend errors to backend for tracking.
 * Auto-enriches with browser info, page URL, and user agent.
 */
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const getBrowserInfo = () => {
  const ua = navigator.userAgent;
  const lang = navigator.language;
  const w = window.innerWidth;
  const h = window.innerHeight;
  return `${ua} | ${lang} | ${w}x${h}`;
};

export async function reportError({
  errorMessage,
  errorType = 'FrontendError',
  stackTrace = null,
  componentStack = null,
  endpoint = null,
  method = null,
  statusCode = null,
  cause = '',
}) {
  try {
    await fetch(`${API}/errors/report`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        error_message: errorMessage,
        error_type: errorType,
        stack_trace: stackTrace,
        component_stack: componentStack,
        page_url: window.location.href,
        endpoint,
        method,
        status_code: statusCode,
        browser_info: getBrowserInfo(),
        cause: cause || errorType,
      }),
    });
  } catch {
    // Silent — don't let error reporting break the app
  }
}
